import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import Leftnavigation from "./Leftnavigation";
import "./style/student.css";

const Studentsdetails = () => {
    const [students, setStudents] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [currentStudent, setCurrentStudent] = useState({});
    const [message, setMessage] = useState("");

    useEffect(() => {
        // Fetch students data from the backend
        axios
            .get("https://gptkpm.in/backend/admin/getstudentdata.php")
            .then((response) => {
                setStudents(response.data);
                console.log(response.data);
            })
            .catch((error) => {
                console.error("Error fetching students data", error);
            });
    }, []);

    const handleEdit = (student) => {
        setCurrentStudent(student);
        setEditMode(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCurrentStudent((prevState) => {
            const updatedStudent = { ...prevState, [name]: value };

            // Automatically update the total based on boys, girls, and staff
            if (name === "total_boys" || name === "total_girls" || name === "total_staff") {
                updatedStudent.total =
                    parseInt(updatedStudent.total_boys || 0) +
                    parseInt(updatedStudent.total_girls || 0) 
            }

            return updatedStudent;
        });
    };

    const handleUpdate = (e) => {
        e.preventDefault();
        axios
            .post("https://gptkpm.in/backend/admin/updatestudentdata.php", currentStudent)
            .then((response) => {
                if (response.data.success) {
                    setStudents((prev) =>
                        prev.map((student) =>
                            student.id === currentStudent.id ? currentStudent : student
                        )
                    );
                    setEditMode(false);
                    alert("Student details updated successfully!");
                } else {
                    alert("Failed to update student details.");
                }
            })
            .catch((error) => {
                console.error("Error updating student data", error);
                setMessage("An error occurred while updating student details.");
            });
    };

    const closeEditMode = () => {
        setEditMode(false);
        setMessage("");
    };

    return (
        <div className="students-table-container">
            <Header />
            <Leftnavigation />
            <h2>Student And Staff Data Table</h2>

            <div className="student-inner">
                <table className="students-table">
                    <thead>
                        <tr>
                            <th>Total Boys</th>
                            <th>Total Girls</th>
                            <th>Total Staff</th>
                            <th>Department</th>
                            <th>Total</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {students.map((student) => (
                            <tr key={student.id}>
                                <td>{student.total_boys}</td>
                                <td>{student.total_girls}</td>
                                <td>{student.staff}</td>
                                <td>{student.department}</td>
                                <td>{student.total}</td>
                                <td>
                                    <button
                                        className="update-button"
                                        onClick={() => handleEdit(student)}
                                    >
                                        Update
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Popup Modal */}
            {editMode && (
                <div className="popup-backdrop">
                    <div className="popup-container">
                        <button className="close-button" onClick={closeEditMode}>
                            &times;
                        </button>
                        <h3 className="popup-title">Update Student Details</h3>
                        <form className="popup-form" onSubmit={handleUpdate}>
                            <label>
                                Total Boys:
                                <input
                                    type="number"
                                    name="total_boys"
                                    value={currentStudent.total_boys || ""}
                                    onChange={handleChange}
                                />
                            </label>
                            <label>
                                Total Girls:
                                <input
                                    type="number"
                                    name="total_girls"
                                    value={currentStudent.total_girls || ""}
                                    onChange={handleChange}
                                />
                            </label>
                            <label>
                                Total Staff:
                                <input
                                    type="number"
                                    name="total_staff"
                                    value={currentStudent.total_staff || ""}
                                    onChange={handleChange}
                                />
                            </label>
                            <label>
                                Total:
                                <input
                                    type="number"
                                    name="total"
                                    value={currentStudent.total || ""}
                                    readOnly
                                />
                            </label>
                            <label>
                                Department:
                                <input
                                    type="text"
                                    name="department"
                                    value={currentStudent.department || ""}
                                    onChange={handleChange}
                                />
                            </label>
                            <button className="update-button" type="submit">
                                Update
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {message && <div className="update-message">{message}</div>}

            <Footer />
        </div>
    );
};

export default Studentsdetails;
